export const ENABLE_VIDEO_GUIDE = false;
export const ENABLE_PENDO_LOCALLY = false;
export const ENABLE_PENDO_FEEDBACK = true;
